// app/providers.tsx
"use client";
import { SessionProvider } from "next-auth/react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

import { EthereumProviders } from "./components/EthereumProviders";
import PostHogPageView from "./components/PostHogPageView";

if (typeof window !== "undefined") {
  posthog.init("phc_btf7rVamKbjCD7wW7UyCWEGwfa6JWSzWcFbK52IaXLM", {
    api_host: "https://api.speedtracer.xyz",
    capture_pageview: false, // Disable automatic pageview capture, as we capture manually
    advanced_disable_feature_flags: true,
  });
}

const Providers = ({ children }: { children: React.ReactNode }) => (
  <PostHogProvider client={posthog}>
    <EthereumProviders>
      <SessionProvider>{children}</SessionProvider>
    </EthereumProviders>
    <PostHogPageView />
  </PostHogProvider>
);

export default Providers;
